<template>
  <!-- 报警参数 -->
  <div class="alarmParamPage">
    <!-- 第一部分: 基础信息 -->
    <div class="section-box">
      <ConfigBase
        :row-data="rowData"
        :net-params="{ status: configStatus }"
        :coordinator="coordinator"
      ></ConfigBase>
    </div>
    <!-- 第二部分: 配置参数 -->
    <div class="section-box">
      <el-form
        label-position="right"
        label-width="150px"
        label-suffix="："
        v-if="params.alarm_switch.modify !== undefined"
      >
        <el-form-item :label="$t('integration.alarm_switch')">
          <template v-if="mode === 'view'">
            <Modify :item="params.alarm_switch"></Modify>
          </template>
          <el-select v-else v-model="params.alarm_switch.modify" style="width: 250px">
            <el-option value="1" :label="$t('public.open')"></el-option>
            <el-option value="0" :label="$t('public.close')"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="params.alarm_switch && params.alarm_switch.modify === '1'">
          <el-form-item :label="$t('integration.alarm_volume_')">
            <span v-if="mode === 'view'">
              <Modify :item="params.alarm_voice_size"></Modify>
            </span>
            <div
              v-else
              class="slider-wrap"
            >
              <el-slider
                show-stops
                :step="1"
                :min="1"
                :max="10"
                v-model="params.alarm_voice_size.modify"
              ></el-slider>
            </div>
          </el-form-item>
          <el-form-item :label="$t('integration.alarm_time_(seconds)')">
            <span v-if="mode === 'view'">
              <Modify :item="params.alarm_time_size"></Modify>
            </span>
            <el-input
              v-else
              class="input-width"
              v-model="params.alarm_time_size.modify"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('integration.alarm_interval_(seconds)')">
            <span v-if="mode === 'view'">
              <Modify :item="params.alarm_interval_time"></Modify>
            </span>
            <el-input
              v-else
              class="input-width"
              v-model="params.alarm_interval_time.modify"
            ></el-input>
          </el-form-item>
          <el-form-item :label="$t('integration.number_of_alarms')">
            <span v-if="mode === 'view'">
              <Modify :item="params.alarm_size"></Modify>
            </span>
            <el-input
              v-else
              class="input-width"
              v-model="params.alarm_size.modify"
            ></el-input>
          </el-form-item>
        </template>
      </el-form>
      <div class="form-actions" v-if="rowData['configStatus'] !== 1">
        <el-button v-if="mode === 'view'" type="primary" @click="config"
          >{{ $t('integration.to_configure') }}
        </el-button>
        <template v-else>
          <el-button type="primary" @click="cancel"
            >{{ $t('integration.cancel') }}
          </el-button>
          <el-button type="primary" @click="save"
            >{{ $t('integration.preservation') }}
          </el-button>
        </template>
      </div>
    </div>
    <!-- 第三部分: Command (只有存在16进制命令时才显示) -->
    <div class="section-box" v-if="cmd">
      <Command
        :rowData="rowData"
        :cmd="cmd"
        :configList="configList"
        :mode="mode"
      ></Command>
    </div>
  </div>
</template>

<script>
import { gateway02TagSize } from '@/utils/convert'
import { defaultAttrGateway02 } from '../../../config/default'
import { getAlarmConfig, saveAlarmConfig } from '@/api/modules/gateway'
import Command from '../../../components/Command.vue'
import Modify from './component/Modify.vue'
import ConfigBase from '@/pages/equipment/gateway/modal/ConfigDialog/ConfigBase.vue'

export default {
  props: {
    rowData: {
      type: Object
    },
    coordinator: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ConfigBase,
    Command,
    Modify
  },
  data () {
    return {
      mode: 'view',
      gateway02TagSize,
      // 报警参数
      params: JSON.parse(JSON.stringify(defaultAttrGateway02)),
      // 原始数据
      raw: undefined,
      isClickConfig: true,

      // 向设备发送的命令命令
      cmd: '',

      // 当前的状态 1为不可配置
      configStatus: 0,

      // 配置列表
      configList: []
    }
  },
  methods: {
    config () {
      // 保存原始数据 方便回溯
      this.raw = JSON.parse(JSON.stringify(this.params))
      this.mode = 'edit'
    },
    cancel () {
      this.params = { ...this.raw }
      this.mode = 'view'
    },
    save () {
      const params = {}
      Object.keys(this.params).forEach(key => {
        params[key] = this.params[key].modify
      })
      saveAlarmConfig({
        idList: [this.rowData.id],
        ...params
      }).then(res => {
        this.$message.success($t('integration.configuration_successful'))
        this.mode = 'view'
        this.getConfig()
      })
    },
    getConfig () {
      getAlarmConfig({ gatewayId: this.rowData.id }).then(({ result }) => {
        this.params = JSON.parse(JSON.stringify(defaultAttrGateway02))
        Object.keys(defaultAttrGateway02).forEach(key => {
          this.params[key] = {
            modify: defaultAttrGateway02[key]
          }
        })
        if (result) {
          const jsonContent = JSON.parse(result.content)
          this.params = {
            ...this.params,
            ...jsonContent.item
          }
          if (this.params.alarm_voice_size) {
            this.params.alarm_voice_size.modify = parseInt(
              this.params.alarm_voice_size.modify
            )
          }

          this.cmd = jsonContent.cmd
          this.configStatus = result.status
          this.configList = result.responseDeviceConfigLogList
        }
      })
    }
  },
  mounted () {
    if (this.rowData.type === 3) {
      this.getConfig()
    }
  }
}
</script>

<style lang="scss" scoped>
.alarmParamPage {
  .section-box {
    background: #fafbfc;
    border: 1px solid #ebeef5;
    border-left: 3px solid var(--primary-color, #409eff);
    border-radius: 4px;
    padding: 14px 20px;
    margin-bottom: 16px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  }

  .form-actions {
    text-align: right;
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #e4e7ed;
  }

  .input-width {
    width: 250px;
  }

  .slider-wrap {
    width: 250px;
    position: relative;
    margin-top: -5px;
    height: 10px;
  }
}
</style>
